<div>
    <div *ngIf="!this.forcableIsMixte && !this.data.screenTransfer" class="forcable-div">
        <span class="h4-label">Forçable HQ</span>
        <mat-slide-toggle
            class="tv-mat-slide-toggle"
            (change)="selectedScreenForcable($event)"
            [checked]="this.screenForm.get('screenForcable').value === 'Y'">
        </mat-slide-toggle>
    </div>

    <div *ngIf="this.forcableIsMixte && !this.data.screenTransfer" class="forcable-div">
        <button class="forcable-select-button forcable-button">
            <div class="layout-row">
                <mat-chip-set class="tv-container-forcable-chip-list">
                    <mat-chip
                        *ngFor="let choice of forcableChoices"
                        (click)="selectedForcable(choice)"
                        [selected]="this.screenForm.get('screenForcable').value === choice?.id">
                        {{ choice.display }}
                    </mat-chip>
                </mat-chip-set>
            </div>
        </button>
    </div>

    <form [formGroup]="this.screenForm">
        <div class="information-container">
            <div class="block-info">
                <h4 class="title-custom">Général</h4>
                <div class="tv-rect-input-extensible width-190px">
                    <mat-form-field>
                        <mat-label class="label">Date</mat-label>
                        <div>
                            <input matInput formControlName="screenDate" readonly />
                        </div>
                    </mat-form-field>
                </div>

                <div [formGroup]="this.screenHourForm" class="relative">
                    <div class="tv-rect-input-extensible width-190px">
                        <mat-form-field>
                            <mat-label>Intitulé</mat-label>
                            <input
                                [readonly]="screenInClosureDate || !this.data.isCreating || this.data.screenTransfer"
                                matInput
                                placeholder="00:00"
                                formControlName="screenHour"
                                appTimeMask />
                        </mat-form-field>
                    </div>
                </div>

                <div [formGroup]="this.screenHourTheoForm">
                    <div class="tv-rect-input-extensible width-190px">
                        <mat-form-field>
                            <mat-label>Heure Théorique</mat-label>
                            <input
                                [readonly]="screenInClosureDate || this.isRegList || this.data.screenTransfer"
                                matInput
                                placeholder="00:00"
                                formControlName="screenTheoHour"
                                appTimeMask />
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div *ngIf="(this.isRegOffers && !this.data.screenTransfer) || isPrimeOffers" class="block-info">
                <div class="all-reg-duration">
                    <div class="nat-reg-duration">
                        <h4 class="title-custom">Durée NAT</h4>
                        <div class="tv-rect-input-extensible width-190px">
                            <mat-form-field>
                                <mat-label>Durée max.</mat-label>
                                <input [readonly]="screenInClosureDate" matInput formControlName="screenDurMaxNat" type="text" />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="nat-reg-duration">
                        <h4 class="title-custom">Durée REG</h4>
                        <div class="tv-rect-input-extensible width-190px">
                            <mat-form-field>
                                <mat-label>Durée max.</mat-label>
                                <input [readonly]="screenInClosureDate" matInput formControlName="screenDurMaxReg" type="text" />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="tv-rect-input-extensible width-400px">
                    <mat-form-field>
                        <mat-label>Durée total max.</mat-label>
                        <input readonly matInput formControlName="screenDurCalMax" [max]="screenDurCalMax" />
                    </mat-form-field>
                </div>
            </div>

            <div *ngIf="this.isRegOffers && this.data.screenTransfer" class="transfer-block">
                <div class="block-info">
                    <div class="all-reg-duration">
                        <div class="nat-reg-duration">
                            <h4 class="title-custom">Durée NAT</h4>
                            <div class="tv-rect-input-extensible width-190px">
                                <mat-form-field>
                                    <mat-label>Durée max.</mat-label>
                                    <input
                                        [readonly]="screenInClosureDate || this.data.screenTransfer"
                                        matInput
                                        formControlName="screenDurMaxNat"
                                        type="text" />
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="nat-reg-duration">
                            <h4 class="title-custom">Durée REG</h4>
                            <div class="tv-rect-input-extensible width-190px">
                                <mat-form-field>
                                    <mat-label>Durée max.</mat-label>
                                    <input
                                        [readonly]="screenInClosureDate || this.data.screenTransfer"
                                        matInput
                                        formControlName="screenDurMaxReg"
                                        type="text" />
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="tv-rect-input-extensible width-400px">
                            <mat-form-field>
                                <mat-label>Durée total max.</mat-label>
                                <input readonly matInput formControlName="screenDurCalMax" [max]="screenDurCalMax" />
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="block-info">
                    <h4 class="title-custom">Durée souhaitée du futur écran</h4>
                    <div class="tv-rect-input-extensible width-400px">
                        <mat-form-field>
                            <mat-label>Durée max.</mat-label>
                            <input
                                matInput
                                formControlName="screenDurMax"
                                type="text"
                                [max]="screenDurCalMax"
                                placeholder="{{ screenDurCalMax ? screenDurCalMax : '' }}" />
                        </mat-form-field>
                    </div>
                    <div class="tv-rect-input-extensible width-400px">
                        <mat-form-field>
                            <mat-label>Durée ouv.</mat-label>
                            <input matInput formControlName="screenDurOuv" type="text" [max]="screenForm.get('screenDurMax').value" />
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div *ngIf="this.isNatChannels || this.isRegList || (this.isRegSpecial && !this.data.isCreating)" class="block-info">
                <h4 class="title-custom">Durée</h4>
                <div class="tv-rect-input-extensible width-190px">
                    <mat-form-field>
                        <mat-label>Durée max.</mat-label>
                        <input
                            [readonly]="screenInClosureDate || this.isRegList || this.isRegSpecial"
                            matInput
                            formControlName="screenDurMax"
                            type="text"
                            [max]="screenDurCalMax"
                            placeholder="{{ screenDurCalMax ? screenDurCalMax : '' }}" />
                    </mat-form-field>
                </div>
                <div class="tv-rect-input-extensible width-190px">
                    <mat-form-field>
                        <mat-label>Durée ouv.</mat-label>
                        <input
                            [readonly]="screenInClosureDate || this.isRegList || this.isRegSpecial"
                            matInput
                            formControlName="screenDurOuv"
                            type="text"
                            [max]="screenForm.get('screenDurMax').value" />
                    </mat-form-field>
                </div>
            </div>
            <div *ngIf="this.isRegSpecial && this.data.isCreating" class="block-info">
                <h4 class="title-custom">Durée REG</h4>
                <div class="tv-rect-input-extensible width-190px">
                    <mat-form-field>
                        <mat-label>Durée max.</mat-label>
                        <input
                            [readonly]="screenInClosureDate"
                            matInput
                            formControlName="screenDurMaxReg"
                            type="text"
                            [max]="screenDurCalMax" />
                    </mat-form-field>
                </div>
            </div>

            <div formGroupName="screenPrices" class="block-info-tarifs">
                <h4 class="title-custom">Tarifs</h4>
                <ng-container *ngFor="let priceLib of this.libFormated">
                    <div class="tv-rect-input-extensible" [ngClass]="{ 'width-190px': isRegOffers || isPrimeOffers }">
                        <mat-form-field>
                            <mat-label>{{ priceLib.display_label }}</mat-label>
                            <input
                                [readonly]="
                                    (this.isRegOffers && !this.data.isCreating) ||
                                    this.isPrimeOffers ||
                                    (this.isRegSpecial && this.data.isCreating)
                                "
                                thousandsSeparators
                                class="prices-values"
                                matInput
                                formControlName="{{ priceLib.display_input }}" />
                        </mat-form-field>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="information-container">
            <div class="block-info full-width context-block">
                <div>
                    <h4 class="title-custom">Contexte Avant</h4>
                    <div class="tv-rect-input-extensible-no-label width-415px padding-top-10px">
                        <mat-form-field>
                            <input matInput formControlName="screenProgramBefore" type="text" maxlength="64" />
                        </mat-form-field>
                    </div>
                </div>
                <div>
                    <h4 class="title-custom">Contexte Après</h4>
                    <div class="tv-rect-input-extensible-no-label width-415px padding-top-10px">
                        <mat-form-field>
                            <input matInput formControlName="screenProgramAfter" type="text" maxlength="64" />
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
        <div class="information-container">
            <div class="block-info full-width">
                <h4 class="title-custom">Commentaire</h4>
                <div class="tv-rect-input-extensible full-width">
                    <mat-form-field>
                        <input matInput formControlName="screenComment" type="text" maxlength="30" />
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="information-container" *ngIf="!this.data.screenTransfer">
            <div
                *ngIf="this.data.isCreating || (!this.data.isCreating && this.data.screenSelected.length === 1)"
                class="block-info full-width">
                <h4 class="title-custom">Typage</h4>
                <div class="type-container">
                    <ng-container *ngIf="this.selectedType?.length > 0">
                        <mat-chip-set class="tv-chip-dark-square">
                            <mat-chip *ngFor="let type of selectedType">
                                {{ type.libevt }}
                                <button matChipRemove (click)="removeScreenType(type)">
                                    <mat-icon class="icon-cancel">cancel</mat-icon>
                                </button>
                            </mat-chip>
                        </mat-chip-set>
                    </ng-container>
                    <button *ngIf="this.screenTypes" class="tv-ns-small-blue-button lib" (click)="openTypeDialog()">Ajouter +</button>
                </div>
            </div>
            <div *ngIf="!this.data.isCreating && this.data?.screenSelected?.length > 1" class="full-width block-type">
                <div class="width-custom">
                    <h4 class="title-custom">Typage Mixte</h4>
                    <div class="type-container">
                        <ng-container>
                            <mat-chip-set class="tv-chip-dark-square">
                                <ng-container *ngFor="let type of this.selectedType">
                                    <mat-chip>
                                        <ng-container>
                                            <div>
                                                {{ type.libevt }}
                                            </div>
                                        </ng-container>
                                        <button (click)="removeScreenType(type)" matChipRemove>
                                            <mat-icon class="icon-cancel">cancel</mat-icon>
                                        </button>
                                    </mat-chip>
                                </ng-container>
                            </mat-chip-set>
                        </ng-container>
                        <button *ngIf="this.screenTypes" class="tv-ns-small-blue-button lib" (click)="openTypeDialog()">Ajouter +</button>
                    </div>
                </div>
                <div *ngIf="this.screenTypes" class="vertical-separator"></div>
                <div class="width-custom">
                    <h4 class="title-custom">Typage Individuel</h4>
                    <div class="type-container">
                        <ng-container>
                            <mat-chip-set class="tv-chip-dark-square">
                                <ng-container *ngFor="let type of this.individualTypes">
                                    <mat-chip>
                                        <ng-container>
                                            <div>
                                                {{ type.libevt }}
                                            </div>
                                        </ng-container>
                                        <button (click)="removeScreenType(type)" matChipRemove>
                                            <mat-icon class="icon-cancel">cancel</mat-icon>
                                        </button>
                                    </mat-chip>
                                </ng-container>
                            </mat-chip-set>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
